module.exports = __webpack_public_path__ + "static/img/user.14de85bb.png";